module.exports = __webpack_public_path__ + "static/media/A1-37-Disparos-Coordenados-cod145.df358da9.png";